export const API_CLIENT_ID = 'nova-web-app';
